import { Text } from '@src/components';

const AutoUploadInstructions = () => {
  return <h1 data-testid="auto-upload-instructions"><Text t="autoUploadInstructions" /></h1>;
};

export default AutoUploadInstructions;
